import axios from "axios";
import { useEffect, useState } from "react";
import Sidebar from "./layout/Sidebar";

export default function DashboardPanel(){

   const role=localStorage.getItem("role");
   const [data, setData]=useState([]);

   function getAdminData(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/dashboard/secured/getAdminDashboard`)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
   }
    function getUserData(){
        axios.get(`${process.env.REACT_APP_BASE_URL}api/dashboard/secured/getUserDashboard`)
        .then(result=>setData(result.data))
        .catch(err=>console.log(err));
   }
   if(role==="Admin"){ useEffect(()=>getAdminData(),[]);}else{useEffect(()=>getUserData(),[]);}

  return (<>
   <div className="container-fluid">
      <div className="row">
         <div className="col-12 col-md-3 col-lg-2 sidebar-container">
             <Sidebar></Sidebar>
         </div>
         <div className="col-12 col-md-9 col-lg-10 main-container">
            <div className="container">
               <div className="row">
                  {role==="Admin" && <>
                  <div className="col col-sm-2 box-shadow">
                     <p>Users</p>
                     <h4>{data.user || "0"}</h4>
                  </div>
                  </>}
                   <div className="col col-sm-2 box-shadow">  
                     <p>Candidates</p>
                     <h4>{data.candidate || "0"}</h4>
                  </div>
                   <div className="col col-sm-2 box-shadow">  
                     <p>Plans</p>
                     <h4>{data.plan || "0"}</h4>
                  </div>
                  <div className="col col-sm-2 box-shadow">
                     <p>Courses</p>
                     <h4>{data.course || "0"}</h4>
                  </div>
                  <div className="col col-sm-2 box-shadow">
                     <p>Questions</p>
                     <h4>{data.question || "0"}</h4>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
  
</>);

}